import { transforms } from "@react-thermal-printer/image";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Br,
  Cashdraw,
  Cut,
  Image,
  Line,
  Printer,
  QRCode,
  Row,
  Text,
  render,
} from "react-thermal-printer";
import RecycleLogo from "../../../../assets/images/recycle_logo3.svg";
import {
  getOrderDetails,
  getPrinterConfig,
  getRetailDetailsByBranch,
} from "../../../../config/Services";
import { convertToLocalDateTime } from "../all-products/Middleware/commonUtils";
import { getFromLocalStorage, setInLocalStorage } from "../../../../utils/localStorageHelpers";
import { useSnackbar } from "../hooks/SnackbarProvider";
import { Box, CircularProgress, Grid } from "@mui/material";
import recycleLogo from "../../../../assets/images/recycle_logo3.svg";
import Spinner from "../../../../components/Spinner";

const OrderDetailsNew = ({ orderId }) => {
  const showSnackbar = useSnackbar();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [reprint, setReprint] = useState(false);
  const [orderSource, setOrderSource] = useState("pos");
  const [printType, setPrintType] = useState("invoice");
  const [key, setKey] = useState(0);
  const [baseOrderResponse, setBaseOrderResponse] = useState([]);
  const [orderItems, setOrderItems] = useState([]);
  const [baseDetails, setBaseDetails] = useState({});
  const [deliveryAddress, setDeliveryAddress] = useState({});
  const [orderTokenDetails, setOrderTokenDetails] = useState({});
  const [gstBreakupDetails, setGstBreakupDetails] = useState([]);
  const [taxBreakupDetails, setTaxBreakupDetails] = useState([]);
  const [orderDetails, setOrderDetails] = useState({});
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [freeProducts, setFreeProducts] = useState([]);
  const [sessionData, setSessionData] = useState(null);
  const [noGst, setNoGst] = useState([]);
  const [gst1slab, setGst1slab] = useState([]);
  const [gst2slab, setGst2slab] = useState([]);
  const [gst5slab, setGst5slab] = useState([]);
  const [gst6slab, setGst6slab] = useState([]);
  const [gst9slab, setGst9slab] = useState([]);
  const [gst14slab, setGst14slab] = useState([]);
  const [cessItems, setCessItems] = useState([]);
  const [date, setDate] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [retailDetails, setRetailDetails] = useState([]);

  // New state variables for returned and complimentary items
  const [returnedItems, setReturnedItems] = useState([]);
  const [complimentaryItems, setComplimentaryItems] = useState([]);

  const [locationData, setLocationData] = useState(
    JSON.parse(localStorage.getItem("locationData"))
  );
  const [orgConfig, setOrgConfig] = useState({});
  const [billLoder, setBillLoader] = useState();
  const hasSodexo = getFromLocalStorage("paymentMethods")?.includes("SODEXO");

  const isB2cOrder = orderSource === "b2c";
  const isDeliveryOrder = orderSource === "delivery";
  const isReport = printType === "report";
  const appliedOrderDiscount = Number(orderDetails?.totalDiscount ?? 0);

  const retailType = localStorage.getItem("retailType");
  const getAppliedOrderDiscount = (billingDetails) => Number(billingDetails?.appliedDiscount ?? 0);
  const getTotalDiscount = (billingDetails) => Number(billingDetails?.totalDiscount ?? 0);

  const fetchDetails = async (orderId) => {
    setBillLoader(true);
    if (drawerOpen || isReport) {
      setKey((prevKey) => prevKey + 1);
      setBillLoader(false);
      return;
    }
    const rtBrId = localStorage.getItem("locId");
    try {
      const response = await getOrderDetails(orderId, rtBrId);
      setBaseOrderResponse(response?.data?.data?.baseOrderResponse);
      setDeliveryAddress(response?.data?.data?.addressEntityModel?.shippingAddress);
      setDate(convertToLocalDateTime(response?.data?.data?.baseOrderResponse?.createdAt) || "N/A");
      setInvoiceId(response?.data?.data?.baseOrderResponse?.invoiceId);
      setBaseDetails(response?.data?.data?.orderBillingDetails);
      setGstBreakupDetails(response?.data?.data?.gstBreakupDetails);
      setOrderDetails(response?.data?.data?.orderBillingDetails);
      setOrderTokenDetails(response?.data?.data?.orderTokenDetails);

      // Extract taxes from orderBillingDetails.taxes
      let rawTaxes =
        response?.data?.data?.orderBillingDetails?.taxes ||
        [];

      if ((!rawTaxes || rawTaxes.length === 0) && Array.isArray(response?.data?.data?.baseOrderResponse?.orderItemList)) {
        const itemTaxes = [];
        response?.data?.data?.baseOrderResponse?.orderItemList.forEach((item) => {
          if (Array.isArray(item?.taxes)) {
            item.taxes.forEach((it) => {
              const existing = itemTaxes.find(
                (t) => t.taxName === it.taxName && t.rate === it.rate
              );
              if (existing) {
                existing.taxableAmt += Number(it.taxableAmount || 0);
                existing.taxAmount += Number(it.taxAmount || 0);
                existing.totalAmt += Number(it.taxableAmount || 0) + Number(it.taxAmount || 0);
              } else {
                itemTaxes.push({
                  taxName: it.taxName || "Tax",
                  rate: it.rate,
                  taxableAmt: Number(it.taxableAmount || 0),
                  taxAmount: Number(it.taxAmount || 0),
                  totalAmt: Number(it.taxableAmount || 0) + Number(it.taxAmount || 0),
                });
              }
            });
          }
        });
        if (itemTaxes.length > 0) {
          rawTaxes = itemTaxes;
        }
      }

      if (Array.isArray(rawTaxes) && rawTaxes.length > 0) {
        const parsedTaxes = [];
        rawTaxes.forEach((tax) => {
          if (Array.isArray(tax?.rates) && tax.rates.length > 0) {
            tax.rates.forEach((rateObj) => {
              parsedTaxes.push({
                taxName: tax?.taxName || "Tax",
                rate: rateObj?.rate,
                taxableAmt: rateObj?.taxableAmount ?? tax?.totalTaxableAmount ?? 0,
                taxAmount: rateObj?.taxAmount ?? tax?.totalTaxAmount ?? 0,
                totalAmt:
                  (rateObj?.taxableAmount ?? tax?.totalTaxableAmount ?? 0) +
                  (rateObj?.taxAmount ?? tax?.totalTaxAmount ?? 0),
              });
            });
          } else {
            parsedTaxes.push({
              taxName: tax?.taxName || "Tax",
              rate: tax?.rate ?? null,
              taxableAmt: tax?.totalTaxableAmount ?? tax?.taxableAmt ?? 0,
              taxAmount: tax?.totalTaxAmount ?? tax?.taxAmount ?? 0,
              totalAmt:
                tax?.totalAmt ??
                ((tax?.totalTaxableAmount ?? tax?.taxableAmt ?? 0) +
                  (tax?.totalTaxAmount ?? tax?.taxAmount ?? 0)),
            });
          }
        });
        setTaxBreakupDetails(parsedTaxes);
      } else {
        setTaxBreakupDetails([]);
      }

      setFreeProducts(response?.data?.data?.freeProducts);
      setOrderItems(response?.data?.data?.baseOrderResponse?.orderItemList);

      // Separate returned and complimentary items
      const allItems = response?.data?.data?.baseOrderResponse?.orderItemList || [];
      const returned = allItems?.filter((item) => item?.status === "RETURNED");
      // const complimentary = allItems.filter(
      //   (item) => item?.inventoryStatus === "NON_CHARGEABLE" && item?.status !== "RETURNED"
      // );
      const complimentary = allItems?.filter((item) => item?.inventoryStatus === "COMPLEMENTARY");
      setReturnedItems(returned);
      setComplimentaryItems(complimentary);

      // Filter regular items (exclude returned and complimentary)
      const regularItems = allItems?.filter(
        (item) => item?.status !== "RETURNED" && item?.inventoryStatus !== "COMPLEMENTARY"
      );

      setNoGst(
        response?.data?.data?.gstWiseOrderItems["No Gst slab"]?.filter(
          (item) => item?.status !== "RETURNED" && item?.inventoryStatus !== "COMPLEMENTARY"
        ) || []
      );
      setGst1slab(
        response?.data?.data?.gstWiseOrderItems["1.5 cgst and 1.5 sgst slab"]?.filter(
          (item) => item?.status !== "RETURNED" && item?.inventoryStatus !== "COMPLEMENTARY"
        ) || []
      );
      setGst2slab(
        response?.data?.data?.gstWiseOrderItems["2.5 cgst and 2.5 sgst slab"]?.filter(
          (item) => item?.status !== "RETURNED" && item?.inventoryStatus !== "COMPLEMENTARY"
        ) || []
      );
      setGst5slab(
        response?.data?.data?.gstWiseOrderItems["5 cgst and 5 sgst slab"]?.filter(
          (item) => item?.status !== "RETURNED" && item?.inventoryStatus !== "COMPLEMENTARY"
        ) || []
      );
      setGst6slab(
        response?.data?.data?.gstWiseOrderItems["6 cgst and 6 sgst slab"]?.filter(
          (item) => item?.status !== "RETURNED" && item?.inventoryStatus !== "COMPLEMENTARY"
        ) || []
      );
      setGst9slab(
        response?.data?.data?.gstWiseOrderItems["9 cgst and 9 sgst slab"]?.filter(
          (item) => item?.status !== "RETURNED" && item?.inventoryStatus !== "COMPLEMENTARY"
        ) || []
      );
      setGst14slab(
        response?.data?.data?.gstWiseOrderItems["14 cgst and 14 sgst slab"]?.filter(
          (item) => item?.status !== "RETURNED" && item?.inventoryStatus !== "COMPLEMENTARY"
        ) || []
      );

      setCessItems(response?.data?.data?.cessBreakUpDetails || []);
      setGstBreakupDetails(response?.data?.data?.gstBreakupDetails);
      setTotalQuantity(regularItems?.map((item) => item?.quantity).reduce((a, b) => a + b, 0));

      const isCashOrSodexoPayment = response?.data?.data?.orderBillingDetails?.payments.some(
        (payment) => payment?.paymentMethod === "CASH" || payment?.paymentMethod === "SODEXO"
      );

      if (!isCashOrSodexoPayment) {
        setReprint(true);
      }

      let locationDetails = {};
      if (!locationData) {
        try {
          const response = await getRetailDetailsByBranch(rtBrId);
          if (response?.data?.data) {
            localStorage.setItem("locationData", JSON.stringify(response?.data?.data));
            locationDetails = response.data.data;
          }
        } catch (e) {}
      } else {
        locationDetails = locationData;
      }
      setRetailDetails(locationDetails);

      setBillLoader(false);
    } catch (error) {
      setBillLoader(false);
      showSnackbar(error?.response?.data?.message, "error");
    }

    const orgConfig = getFromLocalStorage("orgConfig");
    if (orgConfig) {
      setOrgConfig(orgConfig);
    } else {
      try {
        const orgId = localStorage.getItem("orgId");
        const response = await getPrinterConfig(orgId);
        if (!!response?.data?.es) {
          throw new Error(response?.data?.message);
        }
        setOrgConfig(response?.data?.configuration);
        setInLocalStorage("orgConfig", response?.data?.configuration);
      } catch (error) {
        console.log(error);
      }
    }
    setKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    fetchDetails(orderId);
  }, []);

  const getDeliveryAddress = () => {
    const parts = [
      deliveryAddress?.addressLine1,
      deliveryAddress?.addressLine2,
      deliveryAddress?.city,
      deliveryAddress?.state,
      deliveryAddress?.country,
      deliveryAddress?.pinCode,
    ];

    return parts.filter((item) => Boolean(item)).join(", ");
  };

  // Helper function to render item rows
  const renderItemRow = (e, index) => {
    return (
      <div key={index}>
        <div className="flex-start align-items-fs">
          <p>
            {e?.hsnCode ? `${e?.hsnCode?.slice(0, 4).padEnd(4)}${!!e?.cess ? "*" : " "}` : "NA"}
          </p>
          <p>
            {retailType === "RESTAURANT"
              ? `${e?.productName?.slice(0, 36).padEnd(36)} (${e?.variantName
                  ?.slice(0, 36)
                  .padEnd(36)})`
              : `${e?.productName?.slice(0, 36).padEnd(36)}`}
            {e?.addonProduct?.length > 0 && (
              <>
                <br />
                <span>
                  {`Add Ons: (${e?.addonProduct?.map((addOn) => addOn?.itemName).join(", ")})`}
                </span>
              </>
            )}
          </p>
        </div>
        <Grid container sx={{ justifyContent: "flex-end" }} alignItems="center">
          <Grid item lg={2} md={2} sm={2} xs={2}>
            <p className="center">{`${e?.quantityBySpecs?.toString().slice(0, 3).padStart(3)}`}</p>
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2}>
            <p className="center">{`${e?.mrp?.toString().slice(0, 7).padStart(7)}`}</p>
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2}>
            <p className="center">{`${e?.sellingPrice?.toString().slice(0, 9).padStart(9)}`}</p>
          </Grid>
          <Grid item lg={2} md={2} sm={2} xs={2}>
            <p className="center">{`${e?.subTotal?.toString().slice(0, 9).padStart(9)}`}</p>
          </Grid>
        </Grid>
      </div>
    );
  };

  // Helper function to render GST / Tax breakup table
  const renderGstBreakup = () => {
    if (taxBreakupDetails?.length > 0) {
      return (
        <>
          <p className="bold center">&lt;------------ GST Breakup ------------&gt;</p>
          <hr className="dotted-faded-hr" />
          <Grid container className="flex">
            <Grid item className="bold flex-center" lg={1} md={1} sm={1} xs={1}>
              SNo
            </Grid>
            <Grid item className="bold flex-center" lg={3.5} md={3.5} sm={3.5} xs={3.5}>
              Tax
            </Grid>
            <Grid item className="bold flex-center" lg={2} md={2} sm={2} xs={2}>
              Rate
            </Grid>
            <Grid item className="bold flex-center" lg={3} md={3} sm={3} xs={3}>
              TaxableAmt
            </Grid>
            <Grid item className="bold flex-center" lg={2.5} md={2.5} sm={2.5} xs={2.5}>
              TaxAmt
            </Grid>
          </Grid>
          {taxBreakupDetails.map((item, index) => (
            <Grid container className="flex" key={index}>
              <Grid item className="flex-center" lg={1} md={1} sm={1} xs={1}>
                <p>{index + 1}</p>
              </Grid>
              <Grid item className="flex-center" lg={3.5} md={3.5} sm={3.5} xs={3.5}>
                <p>{item?.taxName}</p>
              </Grid>
              <Grid item className="flex-center" lg={2} md={2} sm={2} xs={2}>
                <p>{item?.rate != null ? `${item?.rate}%` : "-"}</p>
              </Grid>
              <Grid item className="flex-center" lg={3} md={3} sm={3} xs={3}>
                <p>{Number(item?.taxableAmt || 0).toFixed(2)}</p>
              </Grid>
              <Grid item className="flex-center" lg={2.5} md={2.5} sm={2.5} xs={2.5}>
                <p>{Number(item?.taxAmount || 0).toFixed(2)}</p>
              </Grid>
            </Grid>
          ))}
        </>
      );
    }

    if (gstBreakupDetails?.filter((item) => item?.taxableAmt != null)?.length > 0) {
      return (
        <>
          <p className="bold center">&lt;------------ GST Breakup ------------&gt;</p>
          <hr className="dotted-faded-hr" />
          <Grid container className="flex">
            <Grid item className="bold flex-center" lg={1} md={1} sm={1} xs={1}>
              SNo
            </Grid>
            <Grid item className="bold flex-center" lg={4} md={4} sm={4} xs={4}>
              TaxableAmt
            </Grid>
            <Grid item className="bold flex-center" lg={2.1} md={2.1} sm={2.1} xs={2.1}>
              CGST
            </Grid>
            <Grid item className="bold flex-center" lg={2.1} md={2.1} sm={2.1} xs={2.1}>
              SGST
            </Grid>
            <Grid item className="bold flex-center" lg={2.4} md={2.4} sm={2.4} xs={2.4}>
              TotalAmt
            </Grid>
          </Grid>
          {gstBreakupDetails
            ?.filter((item) => item?.taxableAmt != null)
            .map((item, index) => (
              <Grid container className="flex" key={index}>
                <Grid item className="flex-center" lg={1} md={1} sm={1} xs={1} key={index}>
                  <p>{index + 1}</p>
                </Grid>
                <Grid item className="flex-center" lg={4} md={4} sm={4} xs={4} key={index}>
                  <p>{item?.taxableAmt?.toFixed(2)?.toString()?.slice(0, 10)?.padEnd(10)} </p>
                </Grid>
                <Grid
                  item
                  className="flex-center"
                  lg={2.1}
                  md={2.1}
                  sm={2.1}
                  xs={2.1}
                  key={index}
                >
                  <p>{item?.cgst?.toFixed(2)?.toString()?.slice(0, 6)?.padStart(6)}</p>
                </Grid>
                <Grid
                  item
                  className="flex-center"
                  lg={2.1}
                  md={2.1}
                  sm={2.1}
                  xs={2.1}
                  key={index}
                >
                  <p> {item?.sgst?.toFixed(2)?.toString()?.slice(0, 7)?.padStart(7)}</p>
                </Grid>
                <Grid
                  item
                  className="flex-center"
                  lg={2.4}
                  md={2.4}
                  sm={2.4}
                  xs={2.4}
                  key={index}
                >
                  <p>
                    {" "}
                    {item?.totalAmt
                      ? item?.totalAmt?.toFixed(2)?.toString()?.slice(0, 11)?.padStart(11)
                      : "---"}
                  </p>
                </Grid>
              </Grid>
            ))}
        </>
      );
    }

    return null;
  };

  return billLoder ? (
    <Box className="loader-order-details-page">
      <CircularProgress />
    </Box>
  ) : orgConfig?.templateId === "template_001" ? (
    <>
      <div className="center padding">
        <h1>{retailDetails?.displayName || "Store Name"}</h1>
        <p>{retailDetails?.address?.addressLine1 || "AddressLine1"}</p>
        <p>{retailDetails?.address?.addressLine2 || "AddressLine2"}</p>
        <p>
          Phone: {retailDetails?.contacts?.map(({ phoneNo }) => phoneNo).join(" / ") || "PhoneNo"}{" "}
          GSTIN: {retailDetails?.gst || "GSTIN"}
        </p>
        <p>FSSAI: {retailDetails?.fssaiNumber || "11222999000690"}</p>
        <hr className="dotted-faded-hr" />
        <h2 className="bold">TAX INVOICE{(isB2cOrder || isDeliveryOrder) && " (DELIVERY)"}</h2>
        <hr className="dotted-faded-hr" />
        <div className="start">
          <p>Cust No: {baseOrderResponse?.mobileNumber || "N/A"}</p>
          <hr className="dotted-faded-hr" />
          <div className="flex">
            <p>Bill No {isB2cOrder || isDeliveryOrder ? orderId : invoiceId}</p>
            <p>
              {baseOrderResponse?.updatedByName || baseOrderResponse?.createdByName || "N/A"}/
              {baseOrderResponse?.licenseName || "N/A"}
            </p>
          </div>
          <div className="flex">
            <p>{date}</p>
            <p>{baseDetails?.paymentMethod || "N/A"}</p>
          </div>
          <hr className="dotted-faded-hr" />
          <p className="bold">HSN Particulars</p>
          <Grid container alignItems="center" sx={{ justifyContent: "flex-end !important" }}>
            <Grid item lg={2} md={2} sm={2} xs={2}>
              <p className="bold center">Qty</p>
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={2}>
              <p className="bold center">MRP</p>
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={2}>
              <p className="bold center">Rate</p>
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={2}>
              <p className="bold center">Value</p>
            </Grid>
          </Grid>
          <hr className="dotted-faded-hr" />

          {/* Regular Items by GST Slabs */}
          {!!noGst?.length && (
            <>
              {retailType !== "RESTAURANT" && <p className="center bold">{"No CGST + No SGST"}</p>}
              {noGst?.map((e, index) => renderItemRow(e, index))}
            </>
          )}
          {!!gst1slab?.length && (
            <>
              {retailType !== "RESTAURANT" && (
                <p className="center bold">{"1.5% CGST and 1.5% SGST"}</p>
              )}
              {gst1slab?.map((e, index) => renderItemRow(e, index))}
            </>
          )}
          {!!gst2slab?.length && (
            <>
              {retailType !== "RESTAURANT" && (
                <p className="center bold">{"2.5% CGST and 2.5% SGST"}</p>
              )}
              {gst2slab?.map((e, index) => renderItemRow(e, index))}
            </>
          )}
          {!!gst5slab?.length && (
            <>
              {retailType !== "RESTAURANT" && (
                <p className="center bold">{"5% CGST and 5% SGST"}</p>
              )}
              {gst5slab?.map((e, index) => renderItemRow(e, index))}
            </>
          )}
          {!!gst6slab?.length && (
            <>
              {retailType !== "RESTAURANT" && (
                <p className="center bold">{"6% CGST and 6% SGST"}</p>
              )}
              {gst6slab?.map((e, index) => renderItemRow(e, index))}
            </>
          )}
          {!!gst9slab?.length && (
            <>
              {retailType !== "RESTAURANT" && (
                <p className="center bold">{"9% CGST and 9% SGST"}</p>
              )}
              {gst9slab?.map((e, index) => renderItemRow(e, index))}
            </>
          )}
          {!!gst14slab?.length && (
            <>
              {retailType !== "RESTAURANT" && (
                <p className="center bold">{"14% CGST and 14% SGST"}</p>
              )}
              {gst14slab?.map((e, index) => renderItemRow(e, index))}
            </>
          )}

          {/* Returned Items Section */}
          {!!returnedItems?.length && (
            <>
              <hr className="dotted-faded-hr" />
              <p className="center bold" style={{ color: "red" }}>
                {"Returned"}
              </p>
              {returnedItems?.map((e, index) => renderItemRow(e, index))}
            </>
          )}

          {/* Complimentary Items Section */}
          {!!complimentaryItems?.length && (
            <>
              <hr className="dotted-faded-hr" />
              <p className="center bold">{"Complimentary"}</p>
              {complimentaryItems?.map((e, index) => renderItemRow(e, index))}
            </>
          )}

          {!!freeProducts?.length && (
            <>
              <hr className="dotted-faded-hr" />
              <p className="center bold">{"Free Products"}</p>
              {freeProducts?.map((e, index) => renderItemRow(e, index))}
            </>
          )}

          <hr className="dotted-faded-hr" />
          <p className="flex">
            <span className="">Earned Pts: {orderDetails?.earnedPoints || 0} </span>
            <span className="end">Redeemed Points: {orderDetails?.loyaltyPointsValue || 0}</span>
          </p>
          <p className="flex">
            <span className="">Coupons: {orderDetails?.couponValue || 0} </span>
            <span className="end">Loyalty Points: {orderDetails?.loyaltyPoints || 0}</span>
          </p>
          {getAppliedOrderDiscount(orderDetails) > 0 && (
            <p className="flex">
              <span className="">Discount: {getAppliedOrderDiscount(orderDetails)}</span>
            </p>
          )}
          {getTotalDiscount(orderDetails) > 0 && (
            <p className="flex">
              <span className="">Total Discount: {getTotalDiscount(orderDetails)}</span>
            </p>
          )}
          <p className="flex">
            <span className="">Delivery Charges: {orderDetails?.deliveryCharges || 0} </span>
            <span className="">Packing Charges: {orderDetails?.packingCharges || 0} </span>
          </p>
          {isB2cOrder && (
            <div className="flex">
              <p>Delivery Charges: {orderDetails?.deliveryCharges || 0}</p>
              <p>Wallet: {orderDetails?.redeemableWalletBalance || 0}</p>
            </div>
          )}
          <hr className="dotted-faded-hr" />
          <div className="flex">
            <p>
              <span className="bold">Items: {baseOrderResponse?.orderItemList?.length} </span>
              <span className="bold">Qty:{totalQuantity}</span>
            </p>
            <p className="bold">Total Amount: {orderDetails?.grandTotal}</p>
          </div>
          <hr className="dotted-faded-hr" />
          {baseOrderResponse?.tender && (
            <div className="flex">
              <p className="bold">Tender: {baseOrderResponse?.tender}</p>
              <p className="bold">Change: {baseOrderResponse?.balance}</p>
            </div>
          )}
          <hr className="dotted-faded-hr" />
          {renderGstBreakup()}
          {!!cessItems?.length && (
            <>
              <hr className="dotted-faded-hr" />
              <p align="center" className="center bold">
                {"<------------ CESS Breakup ------------>"}
              </p>
              <hr className="dotted-faded-hr" />
              <Grid container className="flex">
                <Grid item className="bold flex-center" lg={1} md={1} sm={1} xs={1}>
                  SNo
                </Grid>
                <Grid item className="bold flex-center" lg={4} md={4} sm={4} xs={4}>
                  TaxableAmt
                </Grid>
                <Grid item className="bold flex-center" lg={3.5} md={3.5} sm={3.5} xs={3.5}>
                  CESS%
                </Grid>
                <Grid item className="bold flex-center" lg={3.5} md={3.5} sm={3.5} xs={3.5}>
                  TotalAmt
                </Grid>
              </Grid>
              <hr className="dotted-faded-hr" />
              <Grid container>
                {cessItems?.map((e, i) => (
                  <>
                    <Grid className="flex-center" lg={1} md={1} sm={1} xs={1}>
                      <p>{`${i + 1} `}</p>
                    </Grid>
                    <Grid className="flex-center" lg={4} md={4} sm={4} xs={4}>
                      <p>{`${e.taxableAmt?.toFixed(2).toString().padEnd(10)} `}</p>
                    </Grid>
                    <Grid className="flex-center" lg={3.5} md={3.5} sm={3.5} xs={3.5}>
                      <p>{`${e.cess?.toString().padStart(4)}%`}</p>
                    </Grid>
                    <Grid className="flex-center" lg={3.5} md={3.5} sm={3.5} xs={3.5}>
                      <p>{`${e.totalAmt?.toFixed(2).toString().padStart(8)}`}</p>
                    </Grid>
                  </>
                ))}
              </Grid>
            </>
          )}
          {deliveryAddress && (
            <>
              <hr className="dotted-faded-hr" />
              <p className="start">{`Shipping Address: ${getDeliveryAddress()}`}</p>
            </>
          )}
          <hr className="dotted-faded-hr" />
          <p className="bold center">Items sold cannot be returned or refunded</p>
          <hr className="dotted-faded-hr" />
          <hr className="dotted-faded-hr" />
          <div className="flex">
            <p className="bold big-text">Total Savings</p>
            <p className="bold big-text">{orderDetails.totalSavings || 0}</p>
          </div>
          <hr className="dotted-faded-hr" />
          <hr className="dotted-faded-hr" />
          {isB2cOrder && (
            <div>
              <p align="center" className="bold" style={{ textDecoration: "underline" }}>
                DELIVERY DETAILS
              </p>
              <p>{`Customer Name: ${baseOrderResponse?.customerName || "N/A"}`}</p>
              <p>{`Mobile: ${baseOrderResponse?.mobileNumber || "N/A"}`}</p>
              <p>{`Address: ${deliveryAddress?.addressLine1 || ""}`}</p>
              <p>
                {`${deliveryAddress?.addressLine2 || ""}, ${deliveryAddress?.city || ""}, ${
                  deliveryAddress?.state || ""
                }`}
              </p>
              <hr />
            </div>
          )}
          {!isB2cOrder && (
            <div className="center">
              <p className="bold center">Please bring your own shopping bags and</p>
              <p className="bold center">Help Save Environment</p>
              <img src={RecycleLogo} />
            </div>
          )}
          {!!retailDetails?.qrFlag && (
            <div>
              <p align="center" bold={true}>
                Twinleaves Grocery App
              </p>
              <p align="center">Scan, Download and Get</p>
              <p style={{ width: "100%", height: "2em", textAlign: "center", fontWeight: "bold" }}>
                FREE Rs.1000*
              </p>
              <p align="center">credit in Twinleaves App wallet!</p>
              <p align="center">Limited Offer! *T&C apply</p>
              <QRCode align="center" content="https://onelink.to/2u8e8a" />
              <p align="center">Available in iOS & Android</p>
              <hr />
            </div>
          )}
          <hr className="dotted-faded-hr" />
          <p className="center">Thank you for shopping with us!</p>
          <p className="center">@Powered by Pallet</p>
        </div>
      </div>
    </>
  ) : (
    <>
      {/* Second template - similar changes needed */}
      <div className="center padding">
        <h1>{retailDetails?.displayName || "Store Name"}</h1>
        <p>{retailDetails?.address?.addressLine1 || "AddressLine1"}</p>
        <p>{retailDetails?.address?.addressLine2 || "AddressLine2"}</p>
        <p>
          Phone: {retailDetails?.contacts?.map(({ phoneNo }) => phoneNo).join(" / ") || "PhoneNo"}{" "}
          GSTIN: {retailDetails?.gst || "GSTIN"}
        </p>
        <p>FSSAI: {retailDetails?.fssaiNumber || "11222999000690"}</p>
        <hr className="dotted-faded-hr" />
        <h2 className="bold">TAX INVOICE{(isB2cOrder || isDeliveryOrder) && " (DELIVERY)"}</h2>
        <hr className="dotted-faded-hr" />
        <div className="start">
          <p>Cust No: {baseOrderResponse?.mobileNumber || "N/A"}</p>
          <hr className="dotted-faded-hr" />
          <div className="flex">
            <p>Bill No {isB2cOrder || isDeliveryOrder ? orderId : invoiceId}</p>
            <p className="">
              {(() => {
                const createdBy = baseOrderResponse?.createdByName;
                if (!createdBy) return "N/A";
                const parts = createdBy.split(".");
                const mainPart = parts[0];
                return mainPart?.length > 8 ? `${mainPart.slice(0, 8)}...` : mainPart;
              })()}/{baseOrderResponse?.licenseName || "N/A"}
            </p>
          </div>
          <div className="flex">
            <p>{date}</p>
            <p>{baseDetails?.paymentMethod || "N/A"}</p>
          </div>
          <hr className="dotted-faded-hr" />
          <p className="bold">HSN Particulars</p>
          <Grid container alignItems="center" sx={{ justifyContent: "flex-end !important" }}>
            <Grid item lg={2} md={2} sm={2} xs={2}>
              <p className="bold center">Qty</p>
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={2}>
              <p className="bold center">MRP</p>
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={2}>
              <p className="bold center">Rate</p>
            </Grid>
            <Grid item lg={2} md={2} sm={2} xs={2}>
              <p className="bold center">Value</p>
            </Grid>
          </Grid>
          <hr className="dotted-faded-hr" />

          {/* Regular Items */}
          {orderItems
            ?.filter(
              (item) => item?.status !== "RETURNED" && item?.inventoryStatus !== "COMPLEMENTARY"
            )
            .map((item, index) => (
              <div key={index}>
                <div className="flex-start align-items-fs">
                  <p>{item?.hsnCode?.slice(0, 4).padEnd(4)}</p>
                  <p>
                    {item?.cess ? "*" : " "} {item?.variantName?.slice(0, 36).padEnd(36)}
                    {item?.addonProduct?.length > 0 && (
                      <>
                        <br />
                        <span>
                          {`Add Ons: (${item?.addonProduct
                            ?.map((addOn) => addOn?.itemName)
                            .join(", ")})`}
                        </span>
                      </>
                    )}
                  </p>
                </div>
                <Grid container sx={{ justifyContent: "flex-end" }} alignItems="center">
                  <Grid item lg={2} md={2} sm={2} xs={2}>
                    <p className="center">{`${item?.quantityBySpecs
                      .toString()
                      .slice(0, 3)
                      .padStart(3)}`}</p>
                  </Grid>
                  <Grid item lg={2} md={2} sm={2} xs={2}>
                    <p className="center">{`${item?.mrp?.toString().slice(0, 7).padStart(7)}`}</p>
                  </Grid>
                  <Grid item lg={2} md={2} sm={2} xs={2}>
                    <p className="center">{`${item?.sellingPrice
                      ?.toString()
                      .slice(0, 9)
                      .padStart(9)}`}</p>
                  </Grid>
                  <Grid item lg={2} md={2} sm={2} xs={2}>
                    <p className="center">{`${item?.subTotal
                      ?.toString()
                      .slice(0, 9)
                      .padStart(9)}`}</p>
                  </Grid>
                  <p></p>
                </Grid>
              </div>
            ))}

          {/* Returned Items Section */}
          {!!returnedItems?.length && (
            <>
              <hr className="dotted-faded-hr" />
              <p className="center bold" style={{ color: "red" }}>
                {"RETURNED ITEMS"}
              </p>
              {returnedItems?.map((e, index) => renderItemRow(e, index))}
            </>
          )}

          {/* Complimentary Items Section */}
          {!!complimentaryItems?.length && (
            <>
              <hr className="dotted-faded-hr" />
              <p className="center bold" style={{ color: "green" }}>
                {"COMPLIMENTARY ITEMS"}
              </p>
              {complimentaryItems?.map((e, index) => renderItemRow(e, index))}
            </>
          )}

          <hr className="dotted-faded-hr" />
          {/* Rest of the template remains the same... */}
          <p className="flex">
            <span className="">Earned Pts: {orderDetails?.earnedPoints || 0} </span>
            <span className="end">Redeemed Points: {orderDetails?.loyaltyPointsValue || 0}</span>
          </p>
          <p className="flex">
            <span className="">Coupons: {orderDetails?.couponValue || 0} </span>
            <span className="end">Loyalty Points: {orderDetails?.loyaltyPoints || 0}</span>
          </p>
          {getAppliedOrderDiscount(orderDetails) > 0 && (
            <p className="flex">
              <span className="">Discount: {getAppliedOrderDiscount(orderDetails)}</span>
            </p>
          )}
          {getTotalDiscount(orderDetails) > 0 && (
            <p className="flex">
              <span className="">Total Discount: {getTotalDiscount(orderDetails)}</span>
            </p>
          )}
          <p className="flex">
            <span className="">Delivery Charges: {orderDetails?.deliveryCharges || 0} </span>
          </p>
          {isB2cOrder && (
            <div className="flex">
              <p>Delivery Charges: {orderDetails?.deliveryCharges || 0}</p>
              <p>Wallet: {orderDetails?.redeemableWalletBalance || 0}</p>
            </div>
          )}
          <hr className="dotted-faded-hr" />
          <div className="flex">
            <p>
              <span className="bold">Items: {baseOrderResponse?.orderItemList?.length} </span>
              <span className="bold">Qty:{totalQuantity}</span>
            </p>
            <p className="bold">Total Amount: {orderDetails?.grandTotal}</p>
          </div>
          <hr className="dotted-faded-hr" />
          {Boolean(Number(baseOrderResponse?.tender)) && (
            <div className="flex">
              <p className="bold">Tender: {baseOrderResponse?.tender}</p>
              <p className="bold">Change: {baseOrderResponse?.balance}</p>
            </div>
          )}
          <hr className="dotted-faded-hr" />
          {baseDetails?.payments?.length > 1 && (
            <>
              {orderDetails?.payments.map((e, index) => (
                <p key={index}>{`${e.paymentMethod}: ${e.amountPaid}`}</p>
              ))}
              <hr className="dotted-faded-hr" />
            </>
          )}
          {renderGstBreakup()}
          {!!cessItems?.length && (
            <>
              <hr className="dotted-faded-hr" />
              <p align="center" className="center bold">
                {"<------------ CESS Breakup ------------>"}
              </p>
              <hr className="dotted-faded-hr" />
              <Grid container className="flex">
                <Grid item className="bold flex-center" lg={1} md={1} sm={1} xs={1}>
                  SNo
                </Grid>
                <Grid item className="bold flex-center" lg={4} md={4} sm={4} xs={4}>
                  TaxableAmt
                </Grid>
                <Grid item className="bold flex-center" lg={3.5} md={3.5} sm={3.5} xs={3.5}>
                  CESS%
                </Grid>
                <Grid item className="bold flex-center" lg={3.5} md={3.5} sm={3.5} xs={3.5}>
                  TotalAmt
                </Grid>
              </Grid>
              <hr className="dotted-faded-hr" />
              <Grid container className="flex">
                {cessItems?.map((e, i) => (
                  <>
                    <Grid className="flex-center" lg={1} md={1} sm={1} xs={1}>
                      <p>{`${i + 1} `}</p>
                    </Grid>
                    <Grid className="flex-center" lg={4} md={4} sm={4} xs={4}>
                      <p>{`${e?.taxableAmt?.toFixed(2).toString().padEnd(10)} `}</p>
                    </Grid>
                    <Grid className="flex-center" lg={3.5} md={3.5} sm={3.5} xs={3.5}>
                      <p>{`${e?.cess?.toString().padStart(4)}%`}</p>
                    </Grid>
                    <Grid className="flex-center" lg={3.5} md={3.5} sm={3.5} xs={3.5}>
                      <p>{`${e?.totalAmt?.toFixed(2).toString().padStart(8)}`}</p>
                    </Grid>
                  </>
                ))}
              </Grid>
            </>
          )}
          {deliveryAddress && (
            <>
              <hr className="dotted-faded-hr" />
              <p className="start">{`Shipping Address: ${getDeliveryAddress()}`}</p>
            </>
          )}
          <hr className="dotted-faded-hr" />
          <p className="bold center">Items sold cannot be returned or refunded</p>
          <hr className="dotted-faded-hr" />
          <hr className="dotted-faded-hr" />
          <div className="flex">
            <p className="bold big-text">Total Savings</p>
            <p className="bold big-text">{orderDetails.totalSavings || 0}</p>
          </div>
          <hr className="dotted-faded-hr" />
          <hr className="dotted-faded-hr" />
          {isB2cOrder && (
            <div>
              <p align="center" className="bold" style={{ textDecoration: "underline" }}>
                DELIVERY DETAILS
              </p>
              <p>{`Customer Name: ${baseOrderResponse?.customerName || "N/A"}`}</p>
              <p>{`Mobile: ${baseOrderResponse?.mobileNumber || "N/A"}`}</p>
              <p>{`Address: ${deliveryAddress?.addressLine1 || ""}`}</p>
              <p>
                {`${deliveryAddress?.addressLine2 || ""}, ${deliveryAddress?.city || ""}, ${
                  deliveryAddress?.state || ""
                }`}
              </p>
              <hr />
            </div>
          )}
          {!isB2cOrder && (
            <div className="center">
              <p className="bold center">Please bring your own shopping bags and</p>
              <p className="bold center">Help Save Environment</p>
              <img src={RecycleLogo} />
            </div>
          )}
          {!!retailDetails?.qrFlag && (
            <div>
              <p align="center" bold={true}>
                Twinleaves Grocery App
              </p>
              <p align="center">Scan, Download and Get</p>
              <p style={{ width: "100%", height: "2em", textAlign: "center", fontWeight: "bold" }}>
                FREE Rs.1000*
              </p>
              <p align="center">credit in Twinleaves App wallet!</p>
              <p align="center">Limited Offer! *T&C apply</p>
              <QRCode align="center" content="https://onelink.to/2u8e8a" />
              <p align="center">Available in iOS & Android</p>
              <hr />
            </div>
          )}
          <hr className="dotted-faded-hr" />
          <p className="center">Thank you for shopping with us!</p>
          <p className="center">@Powered by Pallet</p>
        </div>
      </div>
    </>
  );
};

export default OrderDetailsNew;
